import { spawn } from 'redux-saga/effects'

import kioskModeSaga from './kioskMode'
import volunteersSaga from './volunteers'
import waiversSaga from './waivers'
import timesheetSaga from './timesheet'
import notificationsSaga from './notifications'
import sessionDiagnosticsSaga from './sessionDiagnostics'

// Spawned so that a failure in one of these (e.g. waivers or diagnostics) cannot cancel the
// ones a kiosk operator depends on: roster polling, volunteer search and check-in.
export default function* rootSaga() {
  yield spawn(kioskModeSaga)
  yield spawn(volunteersSaga)
  yield spawn(waiversSaga)
  yield spawn(timesheetSaga)
  yield spawn(notificationsSaga)
  yield spawn(sessionDiagnosticsSaga)
}
